//Types
import {
  ACTUALIZAR_SOLICITUD,
  AGREGAR_SOLICITUD,
  MODIFICAR_FILTROS_ESTADOS_SOLICITUD,
  MODIFICAR_FILTROS_RANGO_SOLICITUD,
  INICIAR_FILTROS_SOLICITUD,
} from "./solicitudesActions";

const solicitudesReducer = (state, action) => {
  switch (action.type) {
    case INICIAR_FILTROS_SOLICITUD: {
      return {
        ...state,
        filtrosEstado: action.payload.filtrosEstado,
        solicitudes: action.payload.solicitudes,
        filtrosEstadoPredeterminado: action.payload.filtrosEstado,
        cargando: false,
      };
    }

    case MODIFICAR_FILTROS_RANGO_SOLICITUD: {
      return {
        ...state,
        filtrosRango: action.payload.filtrosRango,
        solicitudes: action.payload.solicitudes,
        cargando: false,
      };
    }

    case MODIFICAR_FILTROS_ESTADOS_SOLICITUD: {
      return {
        ...state,
        filtrosEstado: action.payload,
        cargando: false,
      };
    }

    case AGREGAR_SOLICITUD: {
      return {
        ...state,
        solicitudes:
          state.solicitudes !== null
            ? [action.payload, ...state.solicitudes]
            : [],
      };
    }

    case ACTUALIZAR_SOLICITUD: {
      return {
        ...state,
        solicitudes: state.solicitudes.map((s) =>
          s._id === action.payload._id ? action.payload : s
        ),
      };
    }

    //xx

    default:
      return state;
  }
};

export default solicitudesReducer;